<div
  class="d-flex align-content-center align-items-center justify-content-center my-3"
>
  <h1 class="me-2">Please Wait<span class="dots">...</span></h1>
</div>
<div
  class="d-flex align-content-center align-items-center justify-content-center my-3"
>
  <div class="setup-steps">
    <ul class="list-unstyled">
      @for (message of messages; track message) {
        <li class="d-flex align-items-center pb-1">
          @if (!message.status) {
            <div
              class="spinner-border text-primary me-2"
              role="status"
              style="width: 24px; height: 24px"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          }
          @if (message.status === true) {
            <div class="me-2">
              <span
                class="text-success rounded-circle border border-success d-flex align-items-center justify-content-center"
                style="width: 24px; height: 24px"
              >
                <i class="bi bi-check"></i>
              </span>
              <span class="visually-hidden">Complete</span>
            </div>
          }
          @if (message.status === "error") {
            <div class="me-2">
              <span
                class="text-danger rounded-circle border border-danger d-flex align-items-center justify-content-center"
                style="width: 24px; height: 24px"
              >
                <i class="bi bi-x"></i>
              </span>
              <span class="visually-hidden">Error</span>
            </div>
          }
          {{ message.name }}
        </li>
      }
    </ul>

    <div class="alert-danger">
      @if (hasError) {
        <div class="alert alert-danger" role="alert">
          <p>Please contact customer service for assistance.</p>
          <p>
            <a
              href="https://scanninja.ai/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open a support ticket
            </a>
          </p>
          <p>
            <!-- logout and try again. -->
            <a
              (click)="logout()"
              (keypress)="logout()"
              class="btn btn-danger"
              tabindex="0"
              >Logout and try again</a
            >
          </p>
        </div>
      }
    </div>
  </div>
</div>
